<template>
  <div class="introduction" id="introduction">
    <div class="layout-content">
      <slot name="subtitle" :data="data">
        <div class="title-competition">
          <div>
            <p class="title-competition-ch">{{data.subTitleEn}}</p>
            <p class="title-competition-en" v-html="data.subTitle"></p>
          </div>

          <img class="title-competition-img" :src="isMobile ? data.mobileTitleImg : data.titleImg" alt="年份图片">
        </div>
        <div class="title-line" />
      </slot>

      <div class="l-content">
        <div class="left">
          <!-- <slot name="year" /> -->

          <p class="left-text" v-for="(p, index) in data.intro" :key="index" v-html="p"></p>
          <p class="left-text ps-test" v-html="data.ps" v-if="data.ps"></p>
        </div>
        <div class="right">
          <i class="bofang" @click="playHandler(data.video)"></i>
          <div class="img-wrap">
            <div class="mask"></div>
            <img class="img-video" :src="data.poster" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SubTitle from '@/components/SubTitle'
import * as GlobalLayer from '@/utils/globalLayer'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    // SubTitle
  },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
    playHandler (video) {
      GlobalLayer.createModal(this.$store, {
        video
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.introduction {
  background-color: $bgGrey;

  @include mobile {
    // padding-top: 70px;
  }
}

.layout-content {
  padding-top: 50px;

  @include mobile {
    padding-top: 25px;
  }
}

.title-competition {
  display: flex; justify-content: space-between; align-items: center;
}

.title-competition-ch {
  margin-bottom: 12px;
  font-size: 60px; font-family:  DIN-BlackItalic;
  color: #303030;
  line-height: 82px;
  letter-spacing: 2px;

  @include mobile {
    font-size: 28px;
    line-height: 38px;
    letter-spacing: 1px;
  }
}

.title-competition-en {
  font-size: 23px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #303030;
  line-height: 31px;
  letter-spacing: 6px;

  @include mobile {
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    letter-spacing: 1px;
  }
}

.title-competition-img {
  width: 100px; height: 100px;

  @include mobile {
    width: 50px; height: 50px;
  }
}

.title-line {
  width: 100px; height: 8px;
  margin: 30px 0 60px;
  background: #DE3640;

  @include mobile {
    width: 34px; height: 3px;
    margin: 7px 0 16px;
  }
}

.l-content {
  display: flex; flex-direction: column; justify-content: space-between; align-items: center;
  color: $gray;

  @include mobile {
    flex-direction: column;
  }

  .left {
    margin-bottom: 60px;
    font-size: 18px; font-weight: 400;
    color: #000000;
    line-height: 35px;

    p:nth-of-type(1) {
      margin-top: 0;
    }

    .left-text {
      margin-top: 20px;
    }

    .ps-test {
      color: rgba(0, 0, 0, 0.5);
    }

    @include enlayoutInner {
      line-height: 1.5;
      text-align: left;
    }

    @include mobile {
      width: auto;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 24px;

      @include enlayoutInner {
        line-height: 20px;
      }
    }
  }

  .right {
    width: 804px; height: 452px;
    position: relative;
    transform: translateX(15px);

    @include mobile {
      width: 100%; height: 188px;
      transform: translateX(0)
      // width: auto; height: 54.36vw;
      // margin-left: -30px;
      // margin-top: 30px;
    }

    i {
      $val: 50px;
      width: 64px; height: 64px;
      position: absolute; z-index: 10;
      @include absoluteCenter;
      display: block;
      background: url('~@/assets/transSave/resource/image/ef/69/efd0026a21de3da79eb68b8cb8a07969.png') center / cover no-repeat;
      cursor: pointer;

      @include mobile {
        width: 40px; height: 40px;
      }
    }

    .img-wrap {
      $padding-top-bottom: 20px;
      $padding-left-right: 30px;
      width: 100%; height: 100%;
      padding: $padding-top-bottom $padding-left-right;
      position: relative;

      @include mobile {
        $padding-top-bottom: 10px;
        $padding-left-right: 22px;
        padding: $padding-top-bottom $padding-left-right;
      }

      img {
        width: 100%; height: 100%;

        @include mobile {
          width: 100%; height: 188px;
        }
      }

      // .mask {
      //   position: absolute; top: $padding-top-bottom; right: $padding-left-right; bottom: $padding-top-bottom; left: $padding-left-right;
      //   background-color: rgba(#000, 0.3);
      // }

      .img-video {
        position: absolute; top: 10px; right: 0; bottom: 0; left: 10px;
        width: 804px; height: 452px;

        @include mobile {
          top: 0; left: 0;
          width: 100%; height: 188px;
        }
      }
    }

    // video {}
  }
}

</style>
